<header class="site-header">
  <div class="header-shell">
    <a class="brand" routerLink="/" (click)="closeMobileMenu()">
      <img
        class="logo light-logo"
        src="/assets/1af46b97216e4776ce929baf6ff43049c9eed6cf.webp"
        alt="Heyea Logo"
        width="200"
        height="200"
        decoding="async"
      />
      <img
        class="logo dark-logo"
        src="/assets/7a15b717b92f2a0adb485677e847fece4de33cba.webp"
        alt="Heyea Logo"
        width="200"
        height="200"
        decoding="async"
      />
      <span>Heyea</span>
    </a>

    <nav class="desktop-nav" aria-label="Primary navigation">
      <div class="menu-group" (mouseenter)="openFeaturesMenu()" (mouseleave)="scheduleFeaturesClose()">
        <button type="button" class="menu-trigger" [attr.aria-expanded]="showFeaturesMenu()">
          Features <span aria-hidden="true">▾</span>
        </button>

        @if (showFeaturesMenu()) {
        <div class="menu-panel" role="menu" (mouseenter)="openFeaturesMenu()" (mouseleave)="scheduleFeaturesClose()">
          @for (item of featureItems; track item.path) {
          <a [routerLink]="item.path" routerLinkActive="active-link" (click)="closeMobileMenu()">{{ item.label }}</a>
          }
        </div>
        }
      </div>

      <div class="menu-group" (mouseenter)="openSolutionsMenu()" (mouseleave)="scheduleSolutionsClose()">
        <button type="button" class="menu-trigger" [attr.aria-expanded]="showSolutionsMenu()">
          Solutions <span aria-hidden="true">▾</span>
        </button>

        @if (showSolutionsMenu()) {
        <div class="menu-panel" role="menu" (mouseenter)="openSolutionsMenu()" (mouseleave)="scheduleSolutionsClose()">
          @for (item of solutionItems; track item.path) {
          <a [routerLink]="item.path" routerLinkActive="active-link" (click)="closeMobileMenu()">{{ item.label }}</a>
          }
        </div>
        }
      </div>

      @for (item of primaryItems; track item.path) {
      <a [routerLink]="item.path" routerLinkActive="active-link">{{ item.label }}</a>
      }

      <a routerLink="/contact" routerLinkActive="active-link">Contact</a>
    </nav>

    <div class="header-actions">
      <app-theme-toggle></app-theme-toggle>
      <a class="sign-in-btn" href="https://app.heyea.ai/auth/login">Sign In</a>
      <a class="trial-btn" href="https://app.heyea.ai/auth/signup">Start Free Trial</a>
      <button type="button" class="mobile-toggle" (click)="toggleMobileMenu()" [attr.aria-expanded]="mobileMenuOpen()">
        <span aria-hidden="true">{{ mobileMenuOpen() ? '✕' : '☰' }}</span>
        <span class="sr-only">Toggle menu</span>
      </button>
    </div>
  </div>

  @if (mobileMenuOpen()) {
  <div class="mobile-panel" aria-label="Mobile navigation">
    <button type="button" class="mobile-accordion" (click)="toggleMobileFeatures()" [attr.aria-expanded]="mobileFeaturesOpen()">
      Features <span [class.open]="mobileFeaturesOpen()">▾</span>
    </button>

    @if (mobileFeaturesOpen()) {
    <div class="mobile-links">
      @for (item of featureItems; track item.path) {
      <a [routerLink]="item.path" (click)="closeMobileMenu()">{{ item.label }}</a>
      }
    </div>
    }

    <button type="button" class="mobile-accordion" (click)="toggleMobileSolutions()" [attr.aria-expanded]="mobileSolutionsOpen()">
      Solutions <span [class.open]="mobileSolutionsOpen()">▾</span>
    </button>

    @if (mobileSolutionsOpen()) {
    <div class="mobile-links">
      @for (item of solutionItems; track item.path) {
      <a [routerLink]="item.path" (click)="closeMobileMenu()">{{ item.label }}</a>
      }
    </div>
    }

    <div class="mobile-links">
      @for (item of primaryItems; track item.path) {
      <a [routerLink]="item.path" (click)="closeMobileMenu()">{{ item.label }}</a>
      }
      <a routerLink="/contact" (click)="closeMobileMenu()">Contact</a>
    </div>

    <div class="mobile-actions">
      <a href="https://app.heyea.ai/auth/login" (click)="closeMobileMenu()">Sign In</a>
      <a class="trial-link" href="https://app.heyea.ai/auth/signup" (click)="closeMobileMenu()">Start Free Trial</a>

      <div class="mobile-socials">
        @for (social of socialLinks; track social.href) {
        <a [href]="social.href" target="_blank" rel="noopener noreferrer" [attr.aria-label]="social.label">
          <img [src]="social.icon" [alt]="social.label" width="24" height="24" loading="lazy" decoding="async" />
        </a>
        }
      </div>
    </div>
  </div>
  }
</header>
